module.exports = __webpack_public_path__ + "img/accessories.077bdc3.png";